import { IParkingEventsModel, IParkingModel, UserService } from '@aggregator/core';
import { ChangeDetectorRef, Component, DestroyRef, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormGroup } from '@angular/forms';
import { LocalizationPipe } from '@shared/modules/localization';
import { MessagesService } from '@shared/modules/messages';
import {
  FormBuilderService,
  IFormGroupConfig,
  ITableActionsColumnReturnData,
  ITableConfig,
  UIFilter,
  UIFormModule,
  UIModalService,
  UIPageContentLayout,
  UITable,
} from '@shared/ui';
import { OperatorParkingEventsDetailsModal } from './components';
import { filterFormConfig, tableConfig } from './configs';
import { ParkingEventsService } from './services/parking-events.service';

@Component({
  selector: 'aggregator-operator-parking-events-page',
  templateUrl: './operator-parking-events.component.html',
  styleUrl: './operator-parking-events.component.scss',
  standalone: true,
  imports: [UIPageContentLayout, UITable, UIFormModule, UIFilter],
  providers: [LocalizationPipe],
})
export class OperatorParkingEventsPage implements OnInit {
  isFilterVisible = false;
  loading = true;
  total = 0;
  pageSize = 20;
  pageIndex = 1;
  listData: IParkingEventsModel[] = [];

  tableConfig: ITableConfig = tableConfig;

  filterForm?: FormGroup;
  filterFormConfig: IFormGroupConfig = filterFormConfig;

  get operatorId(): string | undefined {
    return this.userService.userInfo?.operatorId;
  }

  constructor(
    private formBuilder: FormBuilderService,
    private modalService: UIModalService,
    private service: ParkingEventsService,
    private destroy$: DestroyRef,
    private cdr: ChangeDetectorRef,
    private messagesService: MessagesService,
    private localizationPipe: LocalizationPipe,
    private userService: UserService,
  ) {}

  ngOnInit(): void {
    this.filterForm = this.formBuilder.build(this.filterFormConfig);
  }

  applyFilter(): void {
    this.onFilterCollapsed();
  }

  onFilterCollapsed(): void {
    this.isFilterVisible = !this.isFilterVisible;
    this.cdr.detectChanges();
  }

  loadDataFromServer(): void {
    this.loading = true;

    this.service
      .getAll({
        operatorId: this.operatorId ?? '',
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
      })
      .pipe(takeUntilDestroyed(this.destroy$))
      .subscribe(repsponse => {
        this.listData = repsponse?.value?.items ?? [];
        this.total = repsponse?.value?.total ?? 0;
        this.loading = false;
      });
  }

  onOpenDetailsModal(id?: string): void {
    this.modalService.create(OperatorParkingEventsDetailsModal, id).subscribe(isSuccess => {
      if (isSuccess) {
        this.loadDataFromServer();
      }
    });
  }

  onDeleteItem(data?: IParkingModel): void {
    if (!data?.id) {
      return;
    }
    this.modalService
      .confirm({
        title: 'Вы уверены?',
        description: `Хотите удалить "${this.localizationPipe.transform(data?.name)}"?`,
        buttonColor: 'danger',
        onOk: () => this.service.delete(data?.id),
      })
      .subscribe(isConfirm => {
        if (isConfirm) {
          this.messagesService.showSuccess('Успешно удален!');
          this.loadDataFromServer();
        }
      });
  }

  onTableActionClicked(data: ITableActionsColumnReturnData): void {
    if (data?.type === 'edit') {
      this.onOpenDetailsModal(data?.rowData?.id);
    }
    if (data.type === 'delete') {
      this.onDeleteItem(data?.rowData);
    }
  }
}
